import { Field } from 'common/fields/entities/field'

export const getField = (fields: Field[], id: string) => {
  return fields.find((field) => field.id === id)
}

export const getFieldLabel = (field?: Field) => {
  return field?.caption || ''
}
